import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";

import { FormSectionElements } from "../../entities/formTemplateDataType";
import { DialogBase } from "./DialogBase";
import { renderSearchFilterCheckbox, renderSearchFilterFields, renderSearchButtonConfig } from "../helpers/SearchFilterDialogHelpers";

interface Props {
    ele: FormSectionElements;
    dialogVisible?: boolean;
    isEng: boolean;
    callback;
}

interface State {
    enableSearchFilter: boolean;
    enableSearch: boolean;
}

export class DialogForDateRangeComponent extends DialogBase<Props, State> {

    constructor(props: Props) {
        super(props);

        const ele = this.props.ele;
        const eleAny = ele as any;

        this.state = {
            enableSearchFilter: ele.SearchFilter?.enabled || false,
            enableSearch: eleAny.enableSearch || false,
        };
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Business Rule for " + this.props.ele.ENUTitle : "Business Rule for " + this.props.ele.FRATitle} 
                    footer={this.renderFooter()}
                    visible={this.props.dialogVisible} 
                    style={{ width: '50vw' }} 
                    onHide={() => this.props.callback(false)}>
                    {this.dateRangeFields()}
                </Dialog>
            </>
        );
        return html;
    }

    dateRangeFields = () => {
        let htmlString = [];

        htmlString.push(
            <div key="date-range-fields">
                {this.updateBindingFieldHtml()}

                {this.questionHintHtml()}
            
                {this.emptyErrorMessageHtml()}
              
                {this.errorMessageHtml()}

                {this.hintExpansionTitleHtml()}

                {this.calloutBoxHtml()}
                {this.fieldSizeHtml()}

                {this.scriptHtml()}

                {this.maskSummaryHtml()}

                {this.indentHtml()}

                {this.excludeFromPayload()}

                <div style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #ddd' }}>
                    {renderSearchFilterCheckbox(
                        this.props.ele,
                        this.state.enableSearchFilter,
                        (checked) => this.setState({ enableSearchFilter: checked }),
                        "Enable Date Range Search Filter:"
                    )}

                    {this.state.enableSearchFilter && renderSearchFilterFields(
                        this.props.ele,
                        this.props.isEng,
                        () => this.props.callback()
                    )}
                </div>

                <div style={{ marginTop: '10px' }}>
                    {renderSearchButtonConfig(
                        this.props.ele,
                        this.state.enableSearch,
                        (checked) => this.setState({ enableSearch: checked }),
                        this.props.isEng,
                        () => this.props.callback(),
                        "Enable Search Button:"
                    )}
                </div>

            </div>
        )
        return htmlString;
    }

    // resets state with latest data from props when dialog becomes visible
    componentDidUpdate(prevProps: Props) {
        const ele = this.props.ele;
        const eleAny = ele as any;
        if (!prevProps.dialogVisible && this.props.dialogVisible) {
            this.setState({
                enableSearchFilter: ele.SearchFilter?.enabled || false,
                enableSearch: eleAny.enableSearch || false,
            });
        }
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" 
                    onClick={() => {
                        const {
                            enableSearchFilter,
                            enableSearch,
                        } = this.state;

                        const ele = this.props.ele;
                        const eleAny = ele as any;

                        if (enableSearchFilter) {
                            if (!ele.SearchFilter) {
                                ele.SearchFilter = {};
                            }
                            ele.SearchFilter.enabled = true;
                        } else {
                            if (ele.SearchFilter) {
                                ele.SearchFilter.enabled = false;
                            }
                        }

                        eleAny.enableSearch = enableSearch;
                        if (!enableSearch) {
                            eleAny.searchTargetSummaryListId = null;
                        }
                        
                        this.props.callback(false);
                    }} 
                />

                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />
            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
